<template>
    <NuxtLink
        tag="button"
        :to
        class="block text-15 py-2"
        :class="[
            (open && isActive) || (!open && isActive) ? borderClass : 'border-grey-500',
            {
                'font-semibold': isActive,
                'border-l-2 border-grey-500 pl-3': open,
                'border-l-2 pl-3': !open && isActive,
            }
        ]"
    >
        <slot />
    </NuxtLink>
</template>

<script>
export default {
    props: {
        to: String,
        open: {
            default: false,
            type: Boolean,
        },
        borderClass: {
            default: '!border-green-600',
            type: String,
        },
    },

    computed: {
        isActive() {
            return this.$route.path == this.to
        },
    },
}
</script>
